import React, { Component } from 'react';
import { Breadcrumb, BreadcrumbItem, Card, CardBody, CardHeader, Modal, ModalHeader, ModalBody, Button, Label, Col, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Control, LocalForm, Errors } from 'react-redux-form';
import { Fade, Stagger } from 'react-animation-components';

const required = (val) => val && val.length;
const isNumber = (val) => !isNaN(Number(val));
const maxLength = (len) => (val) => !(val) || (val.length <= len);
const minLength = (len) => (val) => (val) && (val.length >= len);
const passcode = (val) => /autos/.test(val);
// const validEmail = (val) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(val);

function RenderFifteen({ kmFifteen }) {
    if (kmFifteen != null)
        return (
            <Stagger in>
                <Fade in>
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead className="table-dark">
                                <tr>
                                    <th>Every 15,000 km</th>
                                    <th>Next km Check at</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="table-success">
                                    <th><span className="fa fa-chevron-right"></span><span className="fa fa-chevron-right"></span><span className="fa fa-chevron-right"></span></th>
                                    <th>{Number(kmFifteen.km) + 15000} km</th>
                                </tr>
                                <tr className="table-primary">
                                    <th colspan="2">1. Replace engine oil and filter</th>
                                </tr>
                                <tr>
                                    <th colspan="2">2. Replace cabin air filter</th>
                                </tr>
                                <tr>
                                    <th colspan="2">3. Rotate tires</th>
                                </tr>
                                <tr>
                                    <th colspan="2">4. Inspect installation of driver floor mat</th>
                                </tr>
                                <tr>
                                    <th colspan="2">5. Inspect and adjust all fluid levels</th>
                                </tr>
                                <tr>
                                    <th colspan="2">6. Inspect wiper blades</th>
                                </tr>
                                <tr>
                                    <th colspan="2">7. Inspect brake pads, calipers, and rotors</th>
                                </tr>
                                <tr>
                                    <th colspan="2">8. Perform vehicle road test</th>
                                </tr>
                                <tr>
                                    <th colspan="2">9. Reset scheduled maintenance reminder</th>
                                </tr>
                                <tr>
                                    <th colspan="2">Have the following done if you’ve been towing, using a roof carrier,
                                        or carrying heavy loads in the cargo area:</th>
                                </tr>
                                <tr>
                                    <th colspan="2">1. Torque nuts and bolts on chassis and body</th>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </Fade>
            </Stagger>
        );
    else
        return (
            <div></div>
        );
}

function RenderThirty({ kmThirty }) {
    if (kmThirty != null)
        return (
            <Stagger in>
                <Fade in>
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead className="table-dark">
                                <tr>
                                    <th>Every 30,000 km</th>
                                    <th>Next km Check at</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="table-success">
                                    <th><span className="fa fa-chevron-right"></span><span className="fa fa-chevron-right"></span><span className="fa fa-chevron-right"></span></th>
                                    <th>{Number(kmThirty.km) + 30000} km</th>
                                </tr>
                                <tr className="table-primary">
                                    <th colspan="2">1. Replace brake fluid</th>
                                </tr>
                                <tr>
                                    <th colspan="2">2. Inspect axle shaft boots</th>
                                </tr>
                                <tr>
                                    <th colspan="2">3. Inspect steering linkage and boots</th>
                                </tr>
                                <tr>
                                    <th colspan="2">4. Inspect ball joints and dust covers</th>
                                </tr>
                                <tr>
                                    <th colspan="2">5. Inspect exhaust pipes and mountings</th>
                                </tr>
                                <tr>
                                    <th colspan="2">6. Inspect body/chassis</th>
                                </tr>
                                <tr>
                                    <th colspan="2">7. Inspect rack-and-pinion assembly</th>
                                </tr>
                                <tr>
                                    <th colspan="2">8. Inspect brake lines and hoses</th>
                                </tr>
                                <tr>
                                    <th colspan="2">9. Inspect drive belts</th>
                                </tr>
                                <tr>
                                    <th colspan="2">10. Replace smart key battery</th>
                                </tr>
                                <tr>
                                    <th colspan="2">11. Inspect engine air filter</th>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </Fade>
            </Stagger>
        );
    else
        return (
            <div></div>
        );
}

function RenderFourtyfive({ kmFourtyfive }) {
    if (kmFourtyfive != null)
        return (
            <Stagger in>
                <Fade in>
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead className="table-dark">
                                <tr>
                                    <th>Every 45,000 km</th>
                                    <th>Next km Check at</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="table-success">
                                    <th><span className="fa fa-chevron-right"></span><span className="fa fa-chevron-right"></span><span className="fa fa-chevron-right"></span></th>
                                    <th>{Number(kmFourtyfive.km) + 45000} km</th>
                                </tr>
                                <tr className="table-primary">
                                    <th colspan="2">1. Replace differential and transfer case fluid</th>
                                </tr>
                                <tr>
                                    <th colspan="2">2. Inspect automatic transmission for signs of leakage</th>
                                </tr>
                                <tr>
                                    <th colspan="2">3. Inspect brake rotor thickness and runout</th>
                                </tr>
                                <tr>
                                    <th colspan="2">4. Inspect fuel lines and connections, fuel tank band,
                                        and fuel tank vapor system hoses</th>
                                </tr>
                                <tr>
                                    <th colspan="2">5. Inspect fuel tank cap gasket</th>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </Fade>
            </Stagger>
        );
    else
        return (
            <div></div>
        );
}

function RenderSeventyfive({ kmSeventyfive }) {
    if (kmSeventyfive != null)
        return (
            <Stagger in>
                <Fade in>
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead className="table-dark">
                                <tr>
                                    <th>Every 75,000 km</th>
                                    <th>Next km Check at</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="table-success">
                                    <th><span className="fa fa-chevron-right"></span><span className="fa fa-chevron-right"></span><span className="fa fa-chevron-right"></span></th>
                                    <th>{Number(kmSeventyfive.km) + 75000} km</th>
                                </tr>
                                <tr className="table-primary">
                                    <th colspan="2">1. Replace coolant fluid</th>
                                </tr>
                                <tr>
                                    <th colspan="2">2. Replace fuel filter</th>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </Fade>
            </Stagger>
        );
    else
        return (
            <div></div>
        );
}

function RenderNinety({ kmNinety }) {
    if (kmNinety != null)
        return (
            <Stagger in>
                <Fade in>
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead className="table-dark">
                                <tr>
                                    <th>Every 90,000 km</th>
                                    <th>Next km Check at</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="table-success">
                                    <th><span className="fa fa-chevron-right"></span><span className="fa fa-chevron-right"></span><span className="fa fa-chevron-right"></span></th>
                                    <th>{Number(kmNinety.km) + 90000} km</th>
                                </tr>
                                <tr className="table-primary">
                                    <th colspan="2">1. Replace transmission fluid</th>
                                </tr>
                                <tr className="table-primary">
                                    <th colspan="2">2. Replace power steering fluid</th>
                                </tr>
                                <tr className="table-primary">
                                    <th colspan="2">3. Replace spark plugs</th>
                                </tr>
                                <tr>
                                    <th colspan="2">4. Inspect vacuum pump for brake booster</th>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </Fade>
            </Stagger>
        );
    else
        return (
            <div></div>
        );
}

class FifteenForm extends Component {

    constructor(props) {
        super(props);

        this.toggleModal = this.toggleModal.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.state = {
            isNavOpen: false,
            isModalOpen: false,
            fifteen: true,
            thirty: false,
            fourtyfive: false,
            seventyfive: false,
            ninety: false,
        };
    }

    toggleModal() {
        this.setState({
            isModalOpen: !this.state.isModalOpen
        });
    }

    handleSubmit(values) {
        this.toggleModal();
        this.props.postAuto(values.km, this.state.fifteen, this.state.thirty, this.state.fourtyfive, this.state.seventyfive, this.state.ninety, values.passcode);
    }

    render() {
        return (
            <div>
                <Button outline onClick={this.toggleModal}><span className="fa fa-plus fa-lg"></span> Submit Maintenance Completion</Button>
                <Modal isOpen={this.state.isModalOpen} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>Submit Maintenance Completion for Every 15k</ModalHeader>
                    <ModalBody>
                        <LocalForm onSubmit={(values) => this.handleSubmit(values)}>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="km">At what km did you complete the maintenance? (please do not include abbr.)</Label>
                                    <Control.text model=".km" id="km"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".km"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="passcode">Passcode:</Label>
                                    <Control.text model=".passcode" id="passcode"
                                        className="form-control"
                                        validators={{
                                            required, passcode
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".passcode"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            passcode: 'Passcode is invalid; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Button type="submit" className="bg-primary">
                                Submit
                            </Button>
                        </LocalForm>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

class ThirtyForm extends Component {

    constructor(props) {
        super(props);

        this.toggleModal = this.toggleModal.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.state = {
            isNavOpen: false,
            isModalOpen: false,
            fifteen: false,
            thirty: true,
            fourtyfive: false,
            seventyfive: false,
            ninety: false
        };
    }

    toggleModal() {
        this.setState({
            isModalOpen: !this.state.isModalOpen
        });
    }

    handleSubmit(values) {
        this.toggleModal();
        this.props.postAuto(values.km, this.state.fifteen, this.state.thirty, this.state.fourtyfive, this.state.seventyfive, this.state.ninety, values.passcode);
    }

    render() {
        return (
            <div>
                <Button outline onClick={this.toggleModal}><span className="fa fa-plus fa-lg"></span> Submit Maintenance Completion</Button>
                <Modal isOpen={this.state.isModalOpen} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>Submit Maintenance Completion for Every 30k</ModalHeader>
                    <ModalBody>
                        <LocalForm onSubmit={(values) => this.handleSubmit(values)}>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="km">At what km did you complete the maintenance? (please do not include abbr.)</Label>
                                    <Control.text model=".km" id="km"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".km"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="passcode">Passcode:</Label>
                                    <Control.text model=".passcode" id="passcode"
                                        className="form-control"
                                        validators={{
                                            required, passcode
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".passcode"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            passcode: 'Passcode is invalid; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Button type="submit" className="bg-primary">
                                Submit
                            </Button>
                        </LocalForm>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

class FourtyfiveForm extends Component {

    constructor(props) {
        super(props);

        this.toggleModal = this.toggleModal.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.state = {
            isNavOpen: false,
            isModalOpen: false,
            fifteen: false,
            thirty: false,
            fourtyfive: true,
            seventyfive: false,
            ninety: false
        };
    }

    toggleModal() {
        this.setState({
            isModalOpen: !this.state.isModalOpen
        });
    }

    handleSubmit(values) {
        this.toggleModal();
        this.props.postAuto(values.km, this.state.fifteen, this.state.thirty, this.state.fourtyfive, this.state.seventyfive, this.state.ninety, values.passcode);
    }

    render() {
        return (
            <div>
                <Button outline onClick={this.toggleModal}><span className="fa fa-plus fa-lg"></span> Submit Maintenance Completion</Button>
                <Modal isOpen={this.state.isModalOpen} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>Submit Maintenance Completion for Every 45k</ModalHeader>
                    <ModalBody>
                        <LocalForm onSubmit={(values) => this.handleSubmit(values)}>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="km">At what km did you complete the maintenance? (please do not include abbr.)</Label>
                                    <Control.text model=".km" id="km"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".km"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="passcode">Passcode:</Label>
                                    <Control.text model=".passcode" id="passcode"
                                        className="form-control"
                                        validators={{
                                            required, passcode
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".passcode"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            passcode: 'Passcode is invalid; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Button type="submit" className="bg-primary">
                                Submit
                            </Button>
                        </LocalForm>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

class SeventyfiveForm extends Component {

    constructor(props) {
        super(props);

        this.toggleModal = this.toggleModal.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.state = {
            isNavOpen: false,
            isModalOpen: false,
            fifteen: false,
            thirty: false,
            fourtyfive: false,
            seventyfive: true,
            ninety: false
        };
    }

    toggleModal() {
        this.setState({
            isModalOpen: !this.state.isModalOpen
        });
    }

    handleSubmit(values) {
        this.toggleModal();
        this.props.postAuto(values.km, this.state.fifteen, this.state.thirty, this.state.fourtyfive, this.state.seventyfive, this.state.ninety, values.passcode);
    }

    render() {
        return (
            <div>
                <Button outline onClick={this.toggleModal}><span className="fa fa-plus fa-lg"></span> Submit Maintenance Completion</Button>
                <Modal isOpen={this.state.isModalOpen} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>Submit Maintenance Completion for Every 75k</ModalHeader>
                    <ModalBody>
                        <LocalForm onSubmit={(values) => this.handleSubmit(values)}>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="km">At what km did you complete the maintenance? (please do not include abbr.)</Label>
                                    <Control.text model=".km" id="km"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".km"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="passcode">Passcode:</Label>
                                    <Control.text model=".passcode" id="passcode"
                                        className="form-control"
                                        validators={{
                                            required, passcode
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".passcode"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            passcode: 'Passcode is invalid; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Button type="submit" className="bg-primary">
                                Submit
                            </Button>
                        </LocalForm>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

class NinetyForm extends Component {

    constructor(props) {
        super(props);

        this.toggleModal = this.toggleModal.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.state = {
            isNavOpen: false,
            isModalOpen: false,
            fifteen: false,
            thirty: false,
            fourtyfive: false,
            seventyfive: false,
            ninety: true
        };
    }

    toggleModal() {
        this.setState({
            isModalOpen: !this.state.isModalOpen
        });
    }

    handleSubmit(values) {
        this.toggleModal();
        this.props.postAuto(values.km, this.state.fifteen, this.state.thirty, this.state.fourtyfive, this.state.seventyfive, this.state.ninety, values.passcode);
    }

    render() {
        return (
            <div>
                <Button outline onClick={this.toggleModal}><span className="fa fa-plus fa-lg"></span> Submit Maintenance Completion</Button>
                <Modal isOpen={this.state.isModalOpen} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>Submit Maintenance Completion for Every 90k</ModalHeader>
                    <ModalBody>
                        <LocalForm onSubmit={(values) => this.handleSubmit(values)}>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="km">At what km did you complete the maintenance? (please do not include abbr.)</Label>
                                    <Control.text model=".km" id="km"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".km"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="passcode">Passcode:</Label>
                                    <Control.text model=".passcode" id="passcode"
                                        className="form-control"
                                        validators={{
                                            required, passcode
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".passcode"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            passcode: 'Passcode is invalid; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Button type="submit" className="bg-primary">
                                Submit
                            </Button>
                        </LocalForm>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

const Auto = (props) => {
    if (props.autosErrMess) {
        return (
            <div className="container">
                <div className="row">
                    <h4>{props.autosErrMess}</h4>
                </div>
            </div>
        );
    }
    else
        return (
            <div className="container">
                <div className="row">
                    <Breadcrumb>
                        <BreadcrumbItem><Link to="/home">Home</Link></BreadcrumbItem>
                        <BreadcrumbItem active>Auto</BreadcrumbItem>
                    </Breadcrumb>
                    <div className="col-12">
                        <h3>Automobile Maintenance</h3>
                        <hr />
                    </div>
                </div>
                <div className="row row-content">
                    <div className="col-12 col-md-6">
                        <h2>Key Maintenance Items</h2>
                        <p>To ensure your journey to high mileage doesn't involve major repairs--and headaches--maintenance and understanding why things are done the way they are is key to reaching that 1 million km milestone.</p>
                        <p><b>Key item <em>replacement details</em> are documented below:</b></p>
                        <h5>1. Engine Oil Information</h5>
                        <ul>
                            <li>Replace every <em><b>15,000 km</b></em> or every <em><b>12 months</b></em> (whichever comes first)</li>
                            <li>Fluid: Fill 5.5 Liters of Toyota 0W-20 Engine Oil</li>
                            <li>Oil Filter: P/N 04152-YZZA1</li>
                            <li>Drain Plug Gasket: P/N 90430-12028</li>
                            <li><em>Upon completion, please reset oil maintenance reminder</em></li>
                        </ul>
                        <h5>2. Brake Fluid Information</h5>
                        <ul>
                            <li>Replace every <em><b>30,000 km</b></em></li>
                            <li>Fluid: Toyota DOT3 or DOT4</li>
                        </ul>
                        <h5>3. Differential and Transfer Case Fluid Information</h5>
                        <ul>
                            <li>Replace every <em><b>45,000 km</b></em></li>
                            <li>Fluid for BOTH Differential and Transfer Case:
                                1 Liter of Toyota Differential
                                Gear Oil LT 75W-85 P/N 08885-02506</li>
                        </ul>
                        <h5>4. Coolant Fluid Information</h5>
                        <ul>
                            <li>Replace every <em><b>75,000 km</b></em></li>
                            <li>Fluid: Zerex Asian Vehicle Coolant (Refer Owners Manual)</li>
                        </ul>
                        <h5>5. Transmission Fluid Information</h5>
                        <ul>
                            <li>Replace every <em><b>90,000 km</b></em></li>
                            <li>Fluid: 4 Liters of Toyota WS Automatic Transmission Fluid</li>
                        </ul>
                        <h5>6. Power Steering Fluid Information</h5>
                        <ul>
                            <li>Replace every <em><b>90,000 km</b></em></li>
                            <li>Fluid: ???</li>
                        </ul>
                        <h5>7. Spark Plugs Information</h5>
                        <ul>
                            <li>Replace every <em><b>90,000 km</b></em></li>
                            <li>Type of Spark Plugs: ???</li>
                        </ul>
                    </div>
                    <div className="col-12 col-md-5">
                        <p></p>
                        <Card>
                            <CardHeader><p><b>Make sure the mechanic uses your specified fluid—or
                                inquire what fluid he/she will use.</b></p>
                                <p><b>(Only use sealed containers)</b></p></CardHeader>
                        </Card>
                    </div>
                    <div className="col-12">
                        <Card>
                            <CardBody className="bg-faded">
                                <blockquote className="blockquote">
                                    <p className="mb-0">Take care of your car in the garage, and the car will take care of you on the road.</p>
                                </blockquote>
                            </CardBody>
                        </Card>
                    </div>
                </div>
                <div className="row row-content">
                    <div className="col-12 col-sm-9">
                        <h2>Inspections:</h2>
                        <div className="col-12 offset-md-10">
                            <FifteenForm postAuto={props.postAuto} />
                            <p></p>
                        </div>
                        <RenderFifteen kmFifteen={props.kmFifteen} />

                        <div className="col-12 offset-md-10">
                            <ThirtyForm postAuto={props.postAuto} />
                            <p></p>
                        </div>
                        <RenderThirty kmThirty={props.kmThirty} />

                        <div className="col-12 offset-md-10">
                            <FourtyfiveForm postAuto={props.postAuto} />
                            <p></p>
                        </div>
                        <RenderFourtyfive kmFourtyfive={props.kmFourtyfive} />

                        <div className="col-12 offset-md-10">
                            <SeventyfiveForm postAuto={props.postAuto} />
                            <p></p>
                        </div>
                        <RenderSeventyfive kmSeventyfive={props.kmSeventyfive} />

                        <div className="col-12 offset-md-10">
                            <NinetyForm postAuto={props.postAuto} />
                            <p></p>
                        </div>
                        <RenderNinety kmNinety={props.kmNinety} />

                    </div>
                </div>
            </div>
        );
}

export default Auto;    


// WEBPACK FOOTER //
// ./src/components/AutoComponent.js